import { Typography } from '@mui/material';
import clsx from 'clsx';

import useContentHeaderStyles from './styles';
import { ContentHeaderProps } from './types';

const ContentHeader: React.FunctionComponent<ContentHeaderProps> = (props) => {
  const { children, variant, component, addons, typographyProps, ...headerProps } = props;
  const classes = useContentHeaderStyles(props);

  const renderAddons = () => {
    if (!addons) {
      return null;
    }
    return <div className={classes.addons}>{addons}</div>;
  };

  const renderContentHeader = () => {
    return (
      <header
        {...headerProps}
        className={clsx(classes.header, headerProps.className)}
        id={`header-${children.toString()}`}
      >
        <Typography {...typographyProps} variant={variant} component={component || 'p'}>
          <strong>{children}</strong>
        </Typography>
        {renderAddons()}
      </header>
    );
  };

  return renderContentHeader();
};

export default ContentHeader;
